import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  ManagerMeResponse,
  requestGetCurrentManagerProfile
} from "./getCurrentManagerProfile.request";

export const COMPANY_MANAGER_ME_QUERY_KEY = "company-manager-me";

const useGetCurrentManagerProfile = (
  options?: QueryOptions<ManagerMeResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: [COMPANY_MANAGER_ME_QUERY_KEY],
    queryFn: requestGetCurrentManagerProfile,
    ...options
  });

  return {
    manager: data?.manager,
    company: data?.company,
    ...rest
  };
};

export default useGetCurrentManagerProfile;
